<template>
    <div class="ion-page">
        <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <!-- <ion-back-button @click="backNavigation"></ion-back-button> -->
                <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                <ion-title>Manage Users to a branch / <span class="ion-sub-title">{{details}}</span> </ion-title>
            </ion-buttons>
            <ion-buttons slot="end">
            <ion-button @click="associateUserToBranch"  v-if="!viewmode">
                <ion-icon slot="start" :icon="add"></ion-icon>Associate User To Branch
            </ion-button>
            </ion-buttons>
        </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <ManageUsersToBranch v-if="!viewmode"/>
        <!-- <AssociateUsersToBranch v-if="viewmode"/> -->
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { add } from 'ionicons/icons';
// @ is an alias to /src
import ManageUsersToBranch from "@/components/corporate/manageUsersToBranch.vue";
import { AppUtils } from "@/util/app-utils"
import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonTitle, IonToolbar } from "@ionic/vue";

export default defineComponent ({
    name: 'manageUserToBranch',
    components: {
        ManageUsersToBranch, IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonIcon, IonContent, IonButton
    },
    data() {
        return {
            add,
            rightToAdd: false,
            viewmode: false,
            manageUser: false,
            branchId: "",
            details: "List",
        }
    },
    mounted() {
        this.branchId = this.$route.params.corporateId;
        this.rightToAdd = new AppUtils().getUserAccess("100|L");
    },
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        },
        associateUserToBranch() {
        this.$router.push({
            name: "associateUserToBranch",
            params: {branchId: this.branchId}
        });
        },
        // backNavigation() {
        
        // // this.$router.go("/corporate/branchDetails");
        // this.$root.$emit('branchId', this.$route.params.corporateId)
        // }
    }
})
</script>